import { motion } from "framer-motion";
import { MessageSquare, Phone, Send, CalendarDays } from "lucide-react";
import { smsHref, telHref, scrollTo } from "@/lib/actions";

const cards = [
  { title: "Text Malcolm", icon: MessageSquare, type: "link", href: smsHref, testid: "start-text", primary: true },
  { title: "Call Malcolm", icon: Phone, type: "link", href: telHref, testid: "start-call" },
  { title: "Send a Request", icon: Send, type: "scroll", target: "#contact", testid: "start-request" },
  { title: "Schedule Appointment", icon: CalendarDays, type: "scroll", target: "#contact", testid: "start-schedule" },
];

export const StartHere = () => {
  return (
    <section id="start" data-testid="start-here-section" className="bg-[#0A0A0A] py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#C8102E]">Start Here</p>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-white leading-[0.95]">
            Tell Malcolm your <span className="text-[#C8102E]">situation.</span>
          </h2>
          <p className="mt-6 text-base lg:text-lg text-gray-400 leading-relaxed">
            You do not need to know exactly what car you want. Tell Malcolm what you are trying to do, what your budget looks like, and what concerns you have. He will help you understand your options and the best next step.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((c, i) => {
            const Icon = c.icon;
            const inner = (
              <>
                <span className={`flex h-14 w-14 items-center justify-center rounded-sm border transition-colors ${c.primary ? "bg-[#C8102E] border-[#C8102E]" : "bg-[#C8102E]/15 border-[#C8102E]/30 group-hover:bg-[#C8102E]"}`}>
                  <Icon size={24} className={c.primary ? "text-white" : "text-[#C8102E] group-hover:text-white transition-colors"} />
                </span>
                <h3 className="mt-6 font-heading text-xl font-bold tracking-tight uppercase text-white">{c.title}</h3>
              </>
            );
            const cls = "group flex flex-col items-start bg-[#121212] border border-white/10 rounded-sm p-8 hover:border-[#C8102E]/50 hover:-translate-y-1 transition-all text-left";
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
              >
                {c.type === "link" ? (
                  <a href={c.href} data-testid={c.testid} className={cls}>{inner}</a>
                ) : (
                  <button onClick={() => scrollTo(c.target)} data-testid={c.testid} className={`${cls} w-full`}>{inner}</button>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
